module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ky-c311ddba04238d23214d3069072caea2.svg";